import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { path: '/', label: '会社概要' },
  { path: '/services', label: '事業紹介' },
  { path: '/contact', label: 'お問合わせ' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-xl border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="px-6 md:px-12 lg:px-20">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 group cursor-pointer">
            <div className="w-10 h-10 md:w-11 md:h-11 rounded-lg bg-primary-800 flex items-center justify-center transition-all duration-300 group-hover:bg-primary-700">
              <span className="text-accent-500 font-bold text-sm md:text-base tracking-widest font-heading">BC</span>
            </div>
            <div className="hidden sm:flex flex-col leading-tight">
              <span className="text-xs md:text-sm text-foreground-600 tracking-[0.15em] font-sans font-light">BANKCARD CHECK</span>
              <span className="text-[10px] md:text-[11px] text-foreground-400 tracking-[0.1em] font-sans font-light">株式会社バンクカード・チェック</span>
            </div>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-10">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`relative text-sm tracking-[0.08em] font-sans font-light transition-colors duration-300 cursor-pointer whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'text-foreground-950'
                    : scrolled
                    ? 'text-foreground-600 hover:text-foreground-950'
                    : 'text-foreground-200 hover:text-white'
                }`}
              >
                {link.label}
                {location.pathname === link.path && (
                  <span className="absolute -bottom-1 left-0 right-0 h-[1.5px] bg-accent-500 rounded-full" />
                )}
              </Link>
            ))}
            <Link
              to="/contact"
              className="ml-2 px-5 py-2 rounded-full border cursor-pointer whitespace-nowrap text-sm tracking-[0.08em] font-sans font-light transition-all duration-300 hover:bg-white/10 border-foreground-300 text-foreground-200 hover:text-white hover:border-white"
            >
              お問合わせ
            </Link>
          </div>

          {/* Mobile Hamburger */}
          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="メニュー"
          >
            <div className="flex flex-col gap-[5px]">
              <span className={`block w-5 h-[1.5px] bg-foreground-950 transition-all duration-300 ${mobileOpen ? 'rotate-45 translate-y-[6.5px]' : ''}`} />
              <span className={`block w-5 h-[1.5px] bg-foreground-950 transition-all duration-300 ${mobileOpen ? 'opacity-0' : ''}`} />
              <span className={`block w-5 h-[1.5px] bg-foreground-950 transition-all duration-300 ${mobileOpen ? '-rotate-45 -translate-y-[6.5px]' : ''}`} />
            </div>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-400 ${
          mobileOpen ? 'max-h-80 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="px-6 pb-6 pt-2 bg-background-50/98 backdrop-blur-xl border-t border-background-200/40 space-y-1">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`block py-3 text-sm tracking-[0.08em] font-sans font-light transition-colors cursor-pointer ${
                location.pathname === link.path
                  ? 'text-foreground-950'
                  : 'text-foreground-600 hover:text-foreground-950'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/contact"
            className="block mt-3 text-center py-3 rounded-full border border-foreground-300 text-sm tracking-[0.08em] font-sans font-light text-foreground-700 hover:bg-foreground-50 transition-colors cursor-pointer"
          >
            お問合わせ
          </Link>
        </div>
      </div>
    </nav>
  );
}